export type ResultItem = { text: string; category: string };

export function normalizeJobResult(result: unknown): ResultItem[] {
  if (!result) return [];
  if (Array.isArray(result)) {
    return result as ResultItem[];
  }
  if (typeof result === 'object' && result !== null) {
    const obj = result as Record<string, unknown> & { results?: unknown };
    if (Array.isArray(obj.results)) {
      return obj.results as ResultItem[];
    }
  }
  return [];
} 